import { memo } from "react";
import { AreaRangeChart, LoadingContent, ProductHierarchyHeading } from "../sharedComponents.index";
import PropTypes from 'prop-types';
import { LOADING_CONTENT_TYPE } from "../LoadingContent/loading.content.constants";
import { useAnalysisViewModel } from "../../../viewModel/useAnalysysViewModel";

export const ProductAccuracyChart = memo(function ProductAccuracyChart({ ctx }) {
  const { productId } = ctx || {};
  
  const vm = useAnalysisViewModel({
    productId: productId,
    shouldFetchPredictionByProduct: true,
    shouldFetchProducts: true
  })

  if (vm.uiState.isLoadingProductPredictions || vm?.uiState?.isLoadingProducts) {
    return (
      <LoadingContent label={"Calculando predições..."} type={LOADING_CONTENT_TYPE.LOCAL_PAGE_STATE}/>
    );
  }

  return (
    <>
      <ProductHierarchyHeading ctx={{ products: vm?.ctx?.products, productId: productId }}/>
      <AreaRangeChart
        xLabels={vm.uiState.xLabels}
        ranges={vm.ctx.adjustConfidenceIntervalToLatestYear}
        lines={vm.ctx.createLines}
        colors={vm.uiState.colors}
        lastHistoricMonthLabel={vm.uiState.lastHistoricMonthLabel}
      />
    </>
  );
})

ProductAccuracyChart.propTypes = { ctx: PropTypes.shape() }